import { render, staticRenderFns } from "./CardArchived.vue?vue&type=template&id=45510ee7"
import script from "./CardArchived.vue?vue&type=script&lang=js"
export * from "./CardArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports